import { createContext, useContext } from 'react';

import { CreateToastOptions } from './Toast.types';

export interface ToastConfig {
  close: (id: number) => void;
  addToast: (options?: CreateToastOptions) => number;
}

export const ToastContext = createContext<ToastConfig | undefined>(undefined);

export function useToastContext() {
  const toastConfig = useContext(ToastContext);

  if (!toastConfig) {
    throw new Error('context is not defined!!!!');
  }

  return toastConfig;
}
